import {
  FETCH_REFFERALS_DATA,
  FETCH_REFFERALS_SUCCESS,
  FETCH_REFFERALS_FAILURE,
  FETCH_REFFERALS_EDIT_DATA,
  FETCH_REFFERALS_EDIT_SUCCESS,
  FETCH_REFFERALS_EDIT_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
  edit: {
    loading: false,
    data: null,
    error: null,
  },
};

const refferals = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REFFERALS_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_REFFERALS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_REFFERALS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_REFFERALS_EDIT_DATA:
      return { ...state, edit: { loading: true, data: null, error: null } };
    case FETCH_REFFERALS_EDIT_SUCCESS:
      return { ...state, edit: { loading: false, data: action.payload, error: null } };
    case FETCH_REFFERALS_EDIT_FAILURE:
      return { ...state, edit: { loading: false, data: null, error: action.payload } };

    default:
      return state;
  }
};

export default refferals;
